(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table-row.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table-row.js');
"use strict";

const _svs$ui$reactTable = svs.ui.reactTable,
  TableRow = _svs$ui$reactTable.TableRow,
  TableCell = _svs$ui$reactTable.TableCell;
const OrderTableRow = _ref => {
  let productName = _ref.productName,
    numberOfVouchers = _ref.numberOfVouchers,
    lastValid = _ref.lastValid,
    singleVoucherValue = _ref.singleVoucherValue;
  const sum = singleVoucherValue * numberOfVouchers;
  const lastValidDate = lastValid && svs.utils.date.SimpleDate(new Date(lastValid));
  return React.createElement(TableRow, null, React.createElement(TableCell, null, productName), React.createElement(TableCell, null, numberOfVouchers), React.createElement(TableCell, null, lastValidDate), React.createElement(TableCell, null, sum));
};
svs.ticket_partner.myOrders.components.OrderTableRow = OrderTableRow;

 })(window);